/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageEventViewDto { 
    /**
     * Id пользователя
     */
    userId?: string;
    /**
     * Имя пользователя
     */
    userName?: string | null;
    /**
     * Время когда оставлено сообщение
     */
    deliveredAt?: string;
    /**
     * Время когда прочитано сообщение
     */
    readAt?: string | null;
}

